export const API_ENDPOINT = '/users/auth'
